(() => {
  if (window.PKAssembly) return;
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  const ids = new Set(['67704265244973', '67704268292397', '67704289165613']);
  const card = () => document.querySelector('[data-pk-assembly]');
  const isService = item => ids.has(String(item.variant_id));
  const fail = (node, key) => {
    const error = new Error('assembly_' + key);
    error.assemblyMessage = node?.dataset[key] || card()?.dataset.error || 'Please review assembly before checkout.';
    return error;
  };
  const request = (path, body) => new Promise((resolve, reject) => {
    const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const options = {credentials:'same-origin',cache:'no-store'};
    if (controller) options.signal = controller.signal;
    if (body) Object.assign(options,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
    let done = false;
    const finish = (fn, value) => { if (done) return; done = true; clearTimeout(timer); fn(value); };
    const timer = setTimeout(() => {
      finish(reject, new Error('cart_request_timeout'));
      if (controller) controller.abort();
    }, 15000);
    Promise.resolve().then(() => window.fetch(root + path, options)).then(async response => {
      const data = await response.json().catch(() => null);
      if (!response.ok) {
        const error = new Error('cart_request_failed');
        const message = data && (data.description || data.message);
        if (typeof message === 'string' && message.length <= 500) error.shopifyMessage = message;
        throw error;
      }
      if (!data) throw new Error('cart_response_invalid');
      return data;
    }).then(data => finish(resolve,data), error => finish(reject,error));
  });
  let ready = false, dirty = false, revision = 0;
  const status = () => {
    const node = card();
    if (!node) return;
    const selected = node.querySelector('input').checked;
    node.querySelector('[data-pk-assembly-status]').textContent = node.dataset[selected ? 'selectedText' : 'optionalText'];
    const button = document.querySelector('[data-pk-pay-checkout]');
    if (button && !button.querySelector('[data-pkj-po-btn]')) {
      if (!button.dataset.assemblyOriginal) button.dataset.assemblyOriginal = button.textContent;
      button.textContent = selected ? node.dataset.checkoutText : button.dataset.assemblyOriginal;
    }
  };
  const initialize = async () => {
    const node = card();
    if (!node) return;
    const checkbox = node.querySelector('[data-pk-assembly-check]');
    const version = ++revision;
    checkbox.disabled = true;
    try {
      const cart = await request('cart.js');
      if (version !== revision) return;
      if (!dirty) checkbox.checked = cart.items.some(item => String(item.variant_id) === node.dataset.serviceId);
      ready = true;
      checkbox.disabled = false;
      status();
    } catch {
      node.querySelector('[data-pk-assembly-status]').textContent = node.dataset.error;
    }
  };
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-pk-assembly-check]')) return;
    dirty = true;
    status();
    try { window.PK?.track?.('pk_assembly_select', {selected:event.target.checked,service_variant:card().dataset.serviceId}); } catch {}
  });
  const prepare = async (variant, cart) => {
    const node = card();
    if (!node || node.dataset.saunaId !== String(variant)) return null;
    const selected = ready ? node.querySelector('input').checked : cart.items.some(item=>String(item.variant_id)===node.dataset.serviceId);
    const intent = {id:node.dataset.serviceId, selected, price:Number(node.dataset.displayPrice), node};
    if (selected) {
      if (node.dataset.previewPrice === 'true') throw fail(node, 'previewError');
      const product = await request('products/' + node.dataset.serviceHandle + '.js');
      const service = product.variants.find(item => String(item.id) === intent.id);
      if (!service?.available || service.requires_shipping || service.price !== intent.price) throw fail(node, 'priceError');
    }
    return intent;
  };
  const sync = async (variant, cart, intent) => {
    const saunaIds = new Set(cart.items.filter(item=>!isService(item)).map(item=>String(item.variant_id)));
    const orphaned = cart.items.filter(item=>isService(item) && item.properties?._pk_assembly_for && !saunaIds.has(String(item.properties._pk_assembly_for)));
    if (orphaned.length) {
      cart = await request('cart/update.js', {updates:Object.fromEntries(orphaned.map(item=>[item.key,0]))});
    }
    if (!intent) return cart;
    const services = cart.items.filter(isService);
    const incompatible = services.filter(item=>String(item.variant_id)!==intent.id);
    if (incompatible.some(item=>!item.properties?._pk_assembly_for)) throw fail(intent.node, 'cartError');
    const matching = services.filter(item=>String(item.variant_id)===intent.id);
    const quantity = cart.items.filter(item=>String(item.variant_id)===String(variant)).reduce((n,item)=>n+item.quantity,0);
    if (!quantity) throw fail(intent.node, 'cartError');
    const updates = Object.fromEntries(incompatible.map(item=>[item.key,0]));
    matching.forEach((item,index)=>{updates[item.key]=intent.selected && index===0 ? quantity : 0;});
    if (Object.keys(updates).length) cart=await request('cart/update.js',{updates});
    if (intent.selected && !matching.length) {
      await request('cart/add.js',{items:[{id:intent.id,quantity,properties:{_pk_assembly_for:String(variant)}}]});
      cart=await request('cart.js');
    }
    const final = cart.items.filter(item=>String(item.variant_id)===intent.id);
    if (intent.selected) {
      if (final.reduce((n,item)=>n+item.quantity,0)!==quantity || final.some(item=>item.requires_shipping || item.original_price!==intent.price)) throw fail(intent.node,'priceError');
      for (const item of final) {
        if (item.properties?._pk_assembly_for!==String(variant)) {
          cart=await request('cart/change.js',{id:item.key,quantity:item.quantity,properties:{...(item.properties||{}),_pk_assembly_for:String(variant)}});
        }
      }
    } else if (final.length) throw fail(intent.node,'cartError');
    return cart;
  };
  window.PKAssembly = {prepare,sync};
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',initialize,{once:true}); else initialize();
  window.addEventListener('pageshow',event=>{if(event.persisted){dirty=false;ready=false;initialize();}});
})();
